import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ymEventsSelector } from '../../../../../selectors/yandexMetrika/ymEventsSelector';

type YMEventsCenterProps = {
  ymCounterId: number;
};

/**
 * @description Центр отправки событий в Яндекс.Метрику
 */
export const YMEventsCenter: FC<YMEventsCenterProps> = props => {
  const { ymCounterId } = props;

  const ymEvents = useSelector(ymEventsSelector);

  const ymPriceChangeEventData = ymEvents?.onPriceChange;

  useEffect(() => {
    /**
     * @description Отправка события в Яндекс.Метрику. Отправляем каждый раз, когда получаем новые данные по выдаче
     */

    if (ymPriceChangeEventData && ym) {
      ym(ymCounterId, ymPriceChangeEventData.eventName, ymPriceChangeEventData.target);
    }
  }, [ymCounterId, ymPriceChangeEventData]);

  return null;
};
